
import React, { Component } from 'react';

//import Game from './game/Game';
//import DirectionOptions from '../gamepage/DirectionOptions';
//import InfoBox from './InfoBox';

import * as Utils from '../../utils/utils';
import Slot from '../gamepage/Slot';

//import RewardAdContainer from '../ads/RewardAdContainer';

import './../../../scss/App.scss';
//import { AD_MORE_TIME_CLICKED, AD_REPLAY_CLICKED, AD_BONUS_CHANCE_VIDEO, AD_SHOW_HINT_CLICKED } from '../../utils/constants';
//import { trackingWrapper } from '../../utils/analytics';
//import SweepsPageOverlay from '../sweepspage';


class Crossword extends Component {

	constructor(props){
		super(props);

		// break up props into local properties
		this.category = this.props.puzzleData.category;
		this.description = this.props.puzzleData.description;
		this.wordsData = this.props.puzzleData.wordsData;

		//

		//this.lettersList = []; // catalog of all available letters in answers for randomized reveal

		// 

		this.gridSize = {
			"rows": 11,
			"cols":11
		}

		//

		this.answersGrid = []; // the answer key to compare with when puzzle is complete

		this.startGrid = []; // the starting puzzle to render

		//

		this.hasFocus = false;
		this.hasWon = false;

		//

		this.state = {
			"gridToRender": [],
			"activeNumber": "",
			"activeDirection": "across",
			"activeSlotRow": "",
			"activeSlotCol": "",
			"activeSlot": null
		}

		//

		this.handleSlotClick = this.handleSlotClick.bind(this);
		this.handleClearBtn = this.handleClearBtn.bind(this);
		this.handleCheckBtn = this.handleCheckBtn.bind(this);
		this.handleRevealLetter = this.handleRevealLetter.bind(this);

		//

		window.ppz.crossword = this;

	}

	componentDidMount(){


		//console.log("Crossword:: componentDidMount");

		// buld array data for a completed puzzle
		this.buildAnswersGrid();

		// build array data for the puzzle with blanked words, represents a new game board
		this.buildStartGrid();

		if(Utils.isPuzzleWon(window.ppz.puzzleData.title)){
			console.log("day has been won");

			// show answers
			this.setState({
				"gridToRender": this.answersGrid
			});

			window.ppz.gamePage.hasWon(true);
			this.hasWon = true;
		}
		else {
			console.log("day not won");

			// update state for render
			this.setState({
				"gridToRender": Utils.deepCopyFunction(this.startGrid)
			});
		}

		// bind input keys
		let _this = this;
		window.$(document).keydown(function(e){
			//console.log("keydown:", e.keyCode);
			
			if(_this.hasFocus){
				_this.handleKeyPress(e.keyCode);
				e.preventDefault();
			}
		});

		//

		// test focus
		window.$("*").bind("click", function(e){
			let target = e.target;

			if(window.$(e.target).hasClass("slot") 
				|| window.$(e.target).hasClass("hg-button") 
				|| window.$(e.target).hasClass("hg-rows")
				|| window.$(e.target).hasClass("hg-row")
				|| window.$(e.target).hasClass("simple-keyboard")
			){
				//console.log("slot clicked", e.target);
			}
			else {
				//console.log("slot NOT clicked", e.target);
				_this.deselectAllSlots();
			}
		});

		//console.log("check start grid", this.startGrid);
	}

	componentWillUnmount(){
		window.$(document).off('keydown');
	}

	componentDidUpdate(prevProps, prevState){
		//console.log("did update");

		// check if game is won
		if(this.checkWinCondition()){
			if(!this.hasWon){
				this.hasWon = true;

				// hide custom keyboard
				window.ppz.customKeyboard.hideKeyboard();

				// play sounds
				window.sounds.win.play();
				window.sounds.winDingDingDing.play();

				//
				window.ppz.gamePage.hasWon(true);

				setTimeout(() => {
					// show win panel
					window.ppz.overlayManager.setPanel("win");
					
				}, 1000);
			}
		}
	}

	buildAnswersGrid(){
		// start with an empty grid matrix
		this.answersGrid = this.createEmptyGrid();

		//

		let allAnswers = "";

		// overwrite empty slots with corresponding words in position
		for(let i = 0; i < this.wordsData.length; i++){
			this.addWordToAnswersGrid(this.wordsData[i], this.answersGrid);
			allAnswers += this.wordsData[i].answer;
		}

		//this.catalogWordsIntoLetters(allAnswers);

		//console.log("check answer grid", this.answersGrid);
	}

	createEmptyGrid(){
		let emptyGrid = Array.from(Array( this.gridSize.rows ), () => new Array( this.gridSize.cols ));

		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				emptyGrid[row][col] = new Slot();
			}
		}

		return emptyGrid;
	}

	/*
	catalogWordsIntoLetters(string){
		this.lettersList = Array.from(Utils.removeDuplicateCharacters(string));
	}
	*/

	addWordToAnswersGrid(wordData, grid){
		let word = wordData.answer;
		let number = wordData.number;
		let rowPosition = wordData.row - 1;
		let colPosition = wordData.col - 1;
		let direction = wordData.direction;

		//console.log("------- word:", word);

		// iterate thru the word's letters and fill-in each slot
		if(direction === "across"){
			for(let i = 0; i < word.length; i++){
				//console.log("grid[rowPosition][(colPosition + i)]", grid[rowPosition][(colPosition + i)]);
				
				grid[rowPosition][(colPosition + i)].text = word.charAt(i);
				grid[rowPosition][(colPosition + i)].col = colPosition + 1 + i;
				grid[rowPosition][(colPosition + i)].row = rowPosition + 1;
				grid[rowPosition][(colPosition + i)].acrossWordStartCol = colPosition + 1;
				grid[rowPosition][(colPosition + i)].acrossWordStartRow = rowPosition + 1;
				grid[rowPosition][(colPosition + i)].isAcross = true;
				grid[rowPosition][(colPosition + i)].isSlot = true;
				grid[rowPosition][(colPosition + i)].acrossNumber = number;
			}
		}
		else if(direction === "down"){
			for(let i = 0; i < word.length; i++){
				grid[(rowPosition + i)][colPosition].text = word.charAt(i);
				grid[(rowPosition + i)][colPosition].col = colPosition + 1;
				grid[(rowPosition + i)][colPosition].row = rowPosition + 1 + i;
				grid[(rowPosition + i)][colPosition].downWordStartCol = colPosition + 1;
				grid[(rowPosition + i)][colPosition].downWordStartRow = rowPosition + 1;
				grid[(rowPosition + i)][colPosition].isDown = true;
				grid[(rowPosition + i)][colPosition].isSlot = true;
				grid[(rowPosition + i)][colPosition].downNumber = number;
			}
		}

		// if is the first letter of the word, include the number data that reflects what appears in the corner of the tile
		grid[rowPosition][colPosition].numberToShow = number;

	}

	buildStartGrid(){
		// use the answer grid and remove all the filled-in letters
		this.startGrid = Utils.deepCopyFunction(this.answersGrid);

		// replace all answers with blank slots
		for(let row = 0; row < this.answersGrid.length; row++){
			for(let col = 0; col < this.answersGrid[row].length; col++){
				let slotData = this.answersGrid[row][col];
				
				if(slotData.text != ""){
					this.startGrid[row][col].text = "";
				}
			}
		}
	}

	removeAllHighlight(gridData){
		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				gridData[row][col].isHighlighted = false;
			}
		}

		return gridData;
	}

	highlightSlots(gridData, direction, number){
		this.removeAllHighlight(gridData);

		if(direction === "across"){

			// loop thru all slots and mark for highlight if corresponds to direction and number
			for(let row = 0; row < this.gridSize.rows; row++){
				for(let col = 0; col < this.gridSize.cols; col++){
					if(gridData[row][col].acrossNumber === number){
						gridData[row][col].isHighlighted = true;
					}
				}
			}
		}
		else if(direction === "down"){

			// loop thru all slots and mark for highlight if corresponds to direction and number
			for(let row = 0; row < this.gridSize.rows; row++){
				for(let col = 0; col < this.gridSize.cols; col++){
					if(gridData[row][col].downNumber === number){
						gridData[row][col].isHighlighted = true;
					}
				}
			}
		}
	}

	removeActiveSlot(gridData){
		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				if(gridData[row][col].isSlot){
					gridData[row][col].isActive = false;
				}
			}
		}
	}

	markActiveSlot(gridData, slotDataRow, slotDataCol){
		// first remove any active slots
		this.removeActiveSlot(gridData);

		// loop thru each slot until matching row and col and mark as active
		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				if(gridData[row][col].row === slotDataRow && gridData[row][col].col === slotDataCol){
					gridData[row][col].isActive = true;
				}
			}
		}
	}

	deselectAllSlots(){
		this.removeActiveSlot(this.state.gridToRender);
		this.removeAllHighlight(this.state.gridToRender);

		this.setState({
			"activeNumber": "",
			"activeDirection": "across",
			"activeSlotRow": "",
			"activeSlotCol": "",
			"activeSlot": null
		});

		// update info box
		window.ppz.infoBox.updateInfo({
			"question": "",
			"number": "",
			"direction": ""
		});

		// hide custom keyboard
		window.ppz.customKeyboard.hideKeyboard();

		// update focus tracker
		this.hasFocus = false;
	}

	toggleDirection(activeDirection){
		if(activeDirection === "across"){
			activeDirection = "down";
		}
		else if(activeDirection === "down"){
			activeDirection = "across";
		}

		return activeDirection;
	}

	clearWrongAnswerMarkers(grid){
		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				grid[row][col].isWrong = false;
			}
		}
	}

	handleSlotClick(slotData){
		//console.log("slotData", slotData);

		let newGridData = Utils.deepCopyFunction(this.state.gridToRender);
		let activeNumber = "";
		let activeDirection = this.state.activeDirection;
		let isDown = slotData.isDown;
		let isAcross = slotData.isAcross;

		//

		this.clearWrongAnswerMarkers(newGridData);

		//console.log("slotdata row: " + slotData.row + "   col: " + slotData.col);

		// mark active slot
		this.markActiveSlot(newGridData, slotData.row, slotData.col);
		
		// highlight associated slots
		// -- if clicked on same slot, toggle direction
		if(slotData.row === this.state.activeSlotRow && slotData.col === this.state.activeSlotCol ){
			activeDirection = this.toggleDirection(activeDirection);
		}

		// -- if slot has corresponding word to the active direction, highlight the direction, otherwise highlight other direction if valid
		if(activeDirection === "across"){
			if(isAcross){
				activeNumber = slotData.acrossNumber;
			}
			else if(isDown){
				activeDirection = "down";
				activeNumber = slotData.downNumber;
			}
		}
		else if(activeDirection === "down"){
			if(isDown){
				activeNumber = slotData.downNumber;
			}
			else if(isAcross){
				activeDirection = "across";
				activeNumber = slotData.acrossNumber;
			}
		}

		this.highlightSlots(newGridData, activeDirection, activeNumber);

		// update states
		this.setState({
			"gridToRender": newGridData,
			"activeNumber": activeNumber,
			"activeDirection": activeDirection,
			"activeSlotRow": slotData.row,
			"activeSlotCol": slotData.col,
			"activeSlot": slotData
		});

		// update info box
		window.ppz.infoBox.updateInfo({
			"question": this.getQuestion(activeNumber, activeDirection),
			"number": activeNumber,
			"direction": activeDirection
		});

		// bring up keyboard
		window.ppz.customKeyboard.showKeyboard();

		// update focus tracker
		this.hasFocus = true;

	}

	getQuestion(number, direction){
		if(number && direction){
			for(let i = 0; i < this.wordsData.length; i++){
				if(this.wordsData[i].number === number && this.wordsData[i].direction === direction){
					return this.wordsData[i].question;
				}
			}
		}
		else {
			for(let i = 0; i < this.wordsData.length; i++){
				if(this.wordsData[i].number === this.state.activeNumber && this.wordsData[i].direction === this.state.activeDirection){
					return this.wordsData[i].question;
				}
			}
		}

		return false;
	}

	handleKeyPress(keyCode){
		let newGridData = Utils.deepCopyFunction(this.state.gridToRender);
		let row = this.state.activeSlotRow - 1;
		let col = this.state.activeSlotCol - 1;

		if(keyCode >= 65 && keyCode <= 90){
			if(this.state.activeSlot !== null){
				newGridData[row][col].text = String.fromCharCode(keyCode);

				const wordIsCorrect = this.lockWordIfCorrect(newGridData);

				this.setState({
					"gridToRender": newGridData
				});

				if(wordIsCorrect){
					this.deselectAllSlots();
					window.sounds.correct.play();
				}
				else {
					this.triggerNextSlot();
				}

				// play sound
				window.sounds.buttonClick.play();
			}
		}
		else if(keyCode == 8){
			if(this.state.activeSlot !== null){
				this.deleteCurrentSlot();
			}
		}
	}

	lockWordIfCorrect(gridData){
		let isCorrect = true;

		let direction = this.state.activeDirection;
		let activeSlot = this.state.activeSlot;
		let number = "";

		if(direction === "across"){
			number = activeSlot.acrossNumber;
		}
		else if(direction === "down"){
			number = activeSlot.downNumber;
		}

		// loop thru all associated slots and check if any are wrong
		let slotsArray = this.getAssociatedSlotsOfWord(number, direction, gridData);

		for(let i = 0; i < slotsArray.length; i++){
			let row = slotsArray[i].row - 1;
			let col = slotsArray[i].col - 1;

			let correctLetter = this.answersGrid[row][col].text;

			if(slotsArray[i].text !== correctLetter){
				isCorrect = false;
			}
		}

		// if all associalted slots are correct, lock them
		if(isCorrect){
			for(let j = 0; j < slotsArray.length; j++){
				slotsArray[j].isLocked = true;
			}

			return true;
		}
		else{
			return false;
		}
	}

	getAssociatedSlotsOfWord(number, direction, gridData){
		let slotsArray = [];

		if(direction === "across"){

			// loop thru all slots and mark for highlight if corresponds to direction and number
			for(let row = 0; row < this.gridSize.rows; row++){
				for(let col = 0; col < this.gridSize.cols; col++){
					if(gridData[row][col].acrossNumber === number){
						slotsArray.push(gridData[row][col]);
					}
				}
			}
		}
		else if(direction === "down"){

			// loop thru all slots and mark for highlight if corresponds to direction and number
			for(let row = 0; row < this.gridSize.rows; row++){
				for(let col = 0; col < this.gridSize.cols; col++){
					if(gridData[row][col].downNumber === number){
						slotsArray.push(gridData[row][col]);
					}
				}
			}
		}

		return slotsArray;
	}


	triggerNextSlot(skip = 0, startSkip = 0){
		//console.log("triggerNextSlot skip: ", skip);

		let direction = this.state.activeDirection;
		let grid = this.state.gridToRender;
		let row = this.state.activeSlotRow - 1;
		let col = this.state.activeSlotCol - 1;

		if(direction == "across"){
			//console.log("----- across");
			// get next slot across for this word, if next slot is blank go back to first tile of word
			try {
				if( grid[row][(col + 1 + skip)].isSlot ){
					//console.log("1");
					
					if(grid[row][(col + 1 + skip)].isLocked){
						//console.log("2 - skip:", skip);

						this.triggerNextSlot(skip+1);
					}
					else {
						//console.log("3");
						this.handleSlotClick( grid[row][(col + 1 + skip)] );
					}
				}
				else {
					//console.log("4");
					let startCol = grid[row][col].acrossWordStartCol - 1;

					if(grid[row][startCol + startSkip].isLocked){
						//console.log("6");
						
						this.triggerNextSlot(skip, (startSkip + 1));
					}
					else {
						//console.log("7");
						this.handleSlotClick( grid[row][(startCol + startSkip)] );
					}
				}
			}
			catch(err) {
				//console.log("5");
				let startCol = grid[row][col].acrossWordStartCol - 1;

				//console.log("startCol: ", startCol);

				if(grid[row][startCol + startSkip].isLocked){
					//console.log("6");
					
					this.triggerNextSlot(skip, (startSkip + 1));
				}
				else {
					//console.log("7");
					this.handleSlotClick( grid[row][(startCol + startSkip)] );
				}
			}
		}
		else if(direction == "down"){
			//console.log("|||| down");
			try {
				if( grid[(row + 1 + skip)][col].isSlot ){
					//console.log("1");

					if( grid[(row + 1 + skip)][col].isLocked ){
						//console.log("2");
						this.triggerNextSlot(skip+1);
					}
					else {
						//console.log("3");
						this.handleSlotClick( grid[(row + 1 + skip)][col] );
					}
				}
				else {
					//console.log("4");
					let startRow = grid[row][col].downWordStartRow - 1;
					
					if(grid[startRow + startSkip][col].isLocked){
						//console.log("6");
						this.triggerNextSlot(skip, (startSkip + 1));
					}
					else {
						//console.log("7");
						this.handleSlotClick( grid[startRow + startSkip][col] );
					}
				}
			}
			catch(err) {
				//console.log("5");
				let startRow = grid[row][col].downWordStartRow - 1;

				if(grid[startRow + startSkip][col].isLocked){
					//console.log("6");
					this.triggerNextSlot(skip, (startSkip + 1));
				}
				else {
					//console.log("7");
					this.handleSlotClick( grid[startRow + startSkip][col] );
				}
			}
		}	
	}

	/* // legacy code - when slots did not have "lock" state to skip over
	triggerNextSlot(){
		let direction = this.state.activeDirection;
		let grid = this.state.gridToRender;
		let row = this.state.activeSlotRow - 1;
		let col = this.state.activeSlotCol - 1;

		if(direction == "across"){
			// get next slot across for this word, if next slot is blank go back to first tile of word
			try {
				if( grid[row][(col + 1)].isSlot ){
					this.handleSlotClick( grid[row][(col + 1)] );
				}
				else {
					let startCol = grid[row][col].acrossWordStartCol - 1;
					this.handleSlotClick( grid[row][(startCol)] );
				}
			}
			catch(err) {
				let startCol = grid[row][col].acrossWordStartCol - 1;
				this.handleSlotClick( grid[row][(startCol)] );
			}
		}
		else if(direction == "down"){
			try {
				if( grid[(row + 1)][col].isSlot ){
					this.handleSlotClick( grid[(row + 1)][col] );
				}
				else {
					let startRow = grid[row][col].downWordStartRow - 1;
					this.handleSlotClick( grid[startRow][col] );
				}
			}
			catch(err) {
				let startRow = grid[row][col].downWordStartRow - 1;
				this.handleSlotClick( grid[startRow][col] );
			}
		}	
	}

	deleteCurrentSlot(){
		let direction = this.state.activeDirection;
		let grid = this.state.gridToRender;
		let row = this.state.activeSlotRow - 1;
		let col = this.state.activeSlotCol - 1;

		// clear current slot
		grid[row][col].text = "";

		this.setState({
			"gridToRender": grid
		});

		// move back one tile
		if(direction == "across"){
			let startCol = grid[row][col].acrossWordStartCol - 1;

			if( (col - 1) >= startCol){
				this.handleSlotClick( grid[row][ (col - 1) ] );
			}
		}
		else if(direction == "down"){
			let startRow = grid[row][col].downWordStartRow - 1;

			if( (row - 1) >= startRow){
				this.handleSlotClick( grid[(row - 1)][col] );
			}
		}	
	}
	*/

	deleteCurrentSlot(skip = 0){
		let direction = this.state.activeDirection;
		let grid = this.state.gridToRender;
		let row = this.state.activeSlotRow - 1;
		let col = this.state.activeSlotCol - 1;

		// clear current slot
		grid[row][col].text = "";

		this.setState({
			"gridToRender": grid
		});

		// move back one tile
		if(direction == "across"){
			let startCol = grid[row][col].acrossWordStartCol - 1;

			if( (col - 1 - skip) >= startCol){
				if(grid[row][col - 1 - skip].isLocked){
					this.deleteCurrentSlot(skip + 1);
				}
				else {
					this.handleSlotClick( grid[row][ (col - 1 - skip) ] );
				}
			}
		}
		else if(direction == "down"){
			let startRow = grid[row][col].downWordStartRow - 1;

			if( (row - 1 - skip) >= startRow){
				if(grid[row - 1 - skip][col].isLocked){
					this.deleteCurrentSlot(skip + 1);
				}
				else {
					this.handleSlotClick( grid[(row - 1 - skip)][col] );
				}
			}
		}	
	}

	checkWinCondition(){
		let isWin = true;
		let answerGrid = this.answersGrid;
		let userGrid = this.state.gridToRender;

		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				if(userGrid[row][col].isSlot){
					if(userGrid[row][col].text !== answerGrid[row][col].text){
						isWin = false;
					}
				}
			}
		}

		return isWin;
	}

	handleClearBtn(){
		let answerGrid = this.answersGrid;
		let userGrid = this.state.gridToRender;
		let newGrid = Utils.deepCopyFunction(this.state.gridToRender);

		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				if(userGrid[row][col].isSlot && userGrid[row][col].text !== ""){
					if(userGrid[row][col].text !== answerGrid[row][col].text){
						newGrid[row][col].isWrong = false;
						newGrid[row][col].text = "";
					}
				}
			}
		}

		this.setState({
			"gridToRender": newGrid
		});

		// play sound
		window.sounds.clearPuzzle.play();
	}

	handleCheckBtn(){
		let answerGrid = this.answersGrid;
		let userGrid = this.state.gridToRender;
		let newGrid = Utils.deepCopyFunction(this.state.gridToRender);
		let hasErrors = false;

		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				if(userGrid[row][col].isSlot && userGrid[row][col].text !== ""){
					if(userGrid[row][col].text !== answerGrid[row][col].text){
						newGrid[row][col].isWrong = true;
						hasErrors = true;
					}
					else {
						newGrid[row][col].isLocked = true;
					}
				}
			}
		}

		this.setState({
			"gridToRender": newGrid
		});

		// if errors are found, play sound
		if(hasErrors){
			window.sounds.errors.play();
			window.ppz.infoBox.showClearBtn(true);
		}
		else {
			window.sounds.correct.play();
			window.ppz.infoBox.showNoErrorsMsg(true);
		}
	}

	/* // old method
	handleRevealLetter(){
		if(this.lettersList.length > 0){
			let randomNo = Math.floor(Math.random() * this.lettersList.length);
			let randomLetter = this.lettersList.splice(randomNo, 1)[0];

			let answerGrid = this.answersGrid;
			let userGrid = this.state.gridToRender;

			for(let row = 0; row < this.gridSize.rows; row++){
				for(let col = 0; col < this.gridSize.cols; col++){
					if(userGrid[row][col].isSlot){
						if(answerGrid[row][col].text === randomLetter){
							userGrid[row][col].text = randomLetter;
						}
					}
				}
			}

			this.setState({
				"gridToRender": userGrid
			});

			// play sound
			window.sounds.letterReveal.play();
		}
	}
	*/

	handleRevealLetter(){
		let newGrid = Utils.deepCopyFunction(this.state.gridToRender);
		let lettersString = "";
		let lettersArray = [];

		// find all empty tiles and get the correct letters, create an array with those letters
		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				if(newGrid[row][col].isSlot && newGrid[row][col].text === ""){
					lettersString += this.answersGrid[row][col].text;
				}
			}
		}

		// remove all duplicate letters and store in array
		lettersArray = Array.from(Utils.removeDuplicateCharacters(lettersString));

		//console.log("lettersArray", lettersArray);

		// choose a letter randomly
		let randomNo = Math.floor(Math.random() * lettersArray.length);
		let randomLetter = lettersArray.splice(randomNo, 1)[0];

		// fill-in the slots with the awarded random letter, mark tile locked
		for(let row = 0; row < this.gridSize.rows; row++){
			for(let col = 0; col < this.gridSize.cols; col++){
				if(newGrid[row][col].isSlot){
					if(this.answersGrid[row][col].text === randomLetter){
						newGrid[row][col].text = randomLetter;
						newGrid[row][col].isLocked = true;
					}
				}
			}
		}

		this.setState({
			"gridToRender": newGrid
		});

		// play sound
		window.sounds.letterReveal.play();
	}

	renderGrid(){
		return (
			<div className="grid">
			{
				this.state.gridToRender.map((item, index) =>
					<div className="row" key={index}>
						{
							item.map((slot, subIndex) => {
								let classes = "slot";

								// for non playable slots (black slots)
								if(slot.isSlot === false){
									classes += " non"
								}

								// number slots
								if(slot.numberToShow !== ""){
									classes += " numbered";
								}

								// if slot should be highlighted
								if(slot.isHighlighted == true){
									classes += " highlighted";
								}

								// if slot should be rendered active state
								if(slot.isActive == true){
									classes += " active";
								}

								// if slot should be rendered active state
								if(slot.isLocked == true){
									classes += " locked";
								}

								// if slot answer is wrong
								let wrongStyle = {"display":"none"};
								if(slot.isWrong == true){
									wrongStyle = {"display":"block"};
								}

								return <div className={classes} key={subIndex} onClick={() => this.handleSlotClick(slot)}>
											<div className="number">{slot.numberToShow}</div>
											{slot.text}
											<div className="wrong" style={wrongStyle}></div>
										</div>
							})
						}
					</div>
				)
			}
			</div>
		);
	}

	render(){
		let hasWonStyle = "";
		if(this.props.hasWon){
			hasWonStyle = " disable";
		}

		return (
			<div className={"crossword" + hasWonStyle}>
				{this.renderGrid()}
			</div>
		);
	}
}

export default Crossword;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/Crossword.js